export class SearchPaymentRequest {
    Facility: string;
    Status: string[];
    PaymentDateFrm: string;
    PaymentDateTo: string;
    PostedDateFrm: string;
    PostedDateTo: string;
    Uuids: string[];
}
